/* eslint-disable @typescript-eslint/no-extraneous-class */
export class LeadSourceDetector {
  static isGenericLead(leadSource?: string): boolean {
    return leadSource === 'general' || leadSource === 'generic' || leadSource === '';
  }

  static isPromotionsLead(leadSource?: string): boolean {
    return leadSource === 'special_offers' || leadSource === 'offers' || leadSource === 'specials';
  }

  static isVTPLead(leadSource?: string, hasVehicle?: boolean): boolean {
    return hasVehicle === true && !this.isPromotionsLead(leadSource);
  }

  static isNGCorMLPLead(leadSource?: string): boolean {
    return leadSource === 'mlp' || leadSource === 'config';
  }

  static getFormType(
    leadSource?: string,
    hasVehicle?: boolean,
  ): 'generic' | 'promotions' | 'vtp' | 'model' | 'specials' {
    if (this.isPromotionsLead(leadSource)) return 'promotions';
    if (this.isVTPLead(leadSource, hasVehicle)) return 'vtp';
    if (this.isNGCorMLPLead(leadSource)) return 'model';
    return 'generic';
  }
}
